export const ypoCookiePolicyConstant = {
    ACCEPT_COOKIES: 'Accept all Cookies',
};

export const getCookiePolicy = (policyLink) => {
    return `YPO and its partners use cookies and similar technologies to improve your Connect browsing ` +
        `experience and to collect information relating to your Connect activities for the purpose of providing ` +
        `you with content. You may disable these cookies in your browser; however, we may not be able to provide ` +
        `you with all or part of the Connect services. By clicking "Accept All Cookies", you consent to our ` +
        `<a href="${policyLink}" data-qe-id="cookie-policy-link" target="_blank">Cookie Policy </a>` +
        `which details how we may collect and use visitor data.`;
};
